export default __webpack_public_path__ + "static/media/3a9e1b1a-9327-4c6c-959f-a2981565baaa.b1170bce.jpeg";